import { RetroQuest } from '@/types/retroPoints';
import { create } from 'zustand';

export interface QuestsActivitiesStore {
  isGameOpen: boolean;
  setIsGameOpen: (isGameOpen: boolean) => void;

  limitedQuests: RetroQuest[];
  setLimitedQuests: (limitedQuests: RetroQuest[]) => void;

  socialQuests: RetroQuest[];
  setSocialQuests: (socialQuests: RetroQuest[]) => void;

  setTaskStatus: (questId: number, status: boolean) => void;

  setQuestAsClaimed: (questId: number) => void;
}

export const questsActivitiesStore = create<QuestsActivitiesStore>(
  (set, get) => ({
    isGameOpen: false,
    setIsGameOpen: isGameOpen => set({ isGameOpen }),

    limitedQuests: [],
    setLimitedQuests: limitedQuests => set({ limitedQuests }),

    socialQuests: [],
    setSocialQuests: socialQuests => set({ socialQuests }),

    setTaskStatus: (questId, status) => {
      const state = get();

      const limitedQuests = state.limitedQuests.map(quest => {
        if (quest.id === questId) {
          return { ...quest, is_completed: status };
        }
        return quest;
      });

      const socialQuests = state.socialQuests.map(quest => {
        if (quest.id === questId) {
          return { ...quest, is_completed: status };
        }
        return quest;
      });

      set({ limitedQuests, socialQuests });
    },

    setQuestAsClaimed: questId => {
      const state = get();

      const limitedQuests = state.limitedQuests.map(quest => {
        if (quest.id === questId) {
          return { ...quest, is_claimed: true };
        }
        return quest;
      });

      const socialQuests = state.socialQuests.map(quest => {
        if (quest.id === questId) {
          return { ...quest, is_claimed: true };
        }
        return quest;
      });

      set({ limitedQuests, socialQuests });
    },
  })
);

export const useQuestsActivities = questsActivitiesStore;
